import React from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow, TableCell } from '@/components/ui/table';
import { CardProgressWrapper } from '@/components/ui/card';

export function StudyGuideQuizDataGrid(props) {
  const { data, height = 'auto' } = props;

  return (
    <div
      className="overflow-y-auto"
      style={{ height: height }}
    >
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead scope="col">Matéria</TableHead>
            <TableHead
              scope="col"
              className="w-[110px] text-right"
            >
              % de acerto
            </TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {data?.map((item, key) => (
            <TableRow key={key}>
              <TableHead scope="row">
                <span
                  className="truncate"
                  title={item.taxonomy}
                >
                  {item.taxonomy}
                </span>
              </TableHead>
              <TableCell>
                <CardProgressWrapper
                  percentage={item.percentage}
                  toFixed={0}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
